import React from "react";

const Home = () => {
  return (
    <main className="home">
      <div className="home-left">
        <h1>A Harm Reduction Guide to Anabolic Androgenic Steroids (Testosterone)</h1>
      </div>

      <div className="home-right">
        <p>
          An evidence-based, community-created harm reduction guide for patients and providers.
        </p>
        <div className="home-btns">
          <a href="#/patients/" className="home-btn">For Patients</a>
          <a href="#/providers/" className="home-btn">For Providers</a>
        </div>
      </div>
    </main>
  )
}

export default Home;